module.exports = __webpack_public_path__ + "img/0Q3A2626_L_WoodMatted.fa5ce041.jpg";